import { createContext } from 'react';

import type { ITaskRunnerContext } from '../types';

export const TaskRunnerContext = createContext({} as ITaskRunnerContext);
